//#region IMPORT
import {
  Unstable_Grid2 as Grid,
} from '@mui/material';
import { AuthButton, Dialog } from '../../../../Components/MUIs';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import { BusinessGridGridCommon } from '../../../../Components/BusinessGridGridCommon';
import {
  getColumnDefs1,
  getColumnDefs2,
  getColumnDefs3,
} from './IND_BASIC_ColumnDefs';
//#endregion

function IND_BASIC(props) {
  const columnDefs1 = getColumnDefs1();
  const columnDefs2 = getColumnDefs2(props);
  const columnDefs3 = getColumnDefs3(props);

  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <AuthButton
          menuId="IndustryMenu"
          printYn="N"
          searchClick={(e) => {
            props.gridRef1?.current?.api?.setQuickFilter(e);
          }}
          saveClick={() => {
            props.SaveLogic1?.();
          }}
          grids={
            <BusinessGridGridCommon
              getRowId1={(params) => String(params.data?.no ?? '')}
              getRowId2={(params) => String(params.data?.no ?? '')}
              gridRef1={props.gridRef1}
              gridRef2={props.gridRef2}
              columnDefs1={columnDefs1}
              columnDefs2={columnDefs2}
              rowData1={props.rowData1}
              rowData2={props.rowData2}
              setSelectedRowData1={props.setSelectedRowData1}
              setSelectedRowData2={props.setSelectedRowData2}
              setChangedRowData2={props.setChangedRowData2}
              title1="구분 정보"
              title2="프로그램ID 정보"
              suppressCellFocus1={true}
              suppressCellFocus2={true}
              addYn1="N"
              addYn2="Y"
              deleteYn1="N"
              deleteYn2="Y"
              addClick2={() => {
                if (props.selectedRowData1.length === 0) {
                  props.dispatch(
                    props.showSnackbar({
                      message: '구분을 선택 후 추가하세요.',
                      type: 'warning',
                    })
                  );
                } else {
                  const plType = props.selectedRowData1?.[0]?.PL_TYPE;
                  if (plType) {
                    props.SearchLogic3?.(plType);
                  }
                  props.setModalToggle1(true);
                }
              }}
              refreshClick1={() => {
                props.SearchLogic1?.();
              }}
              refreshClick2={() => {
                const plType = props.selectedRowData1?.[0]?.PL_TYPE;
                if (plType) {
                  props.SearchLogic2?.(plType);
                }
              }}
              deleteClick2={() => {
                const newRowExists = props.selectedRowData2.some(
                  (row) => row.newYn === 'Y'
                );

                if (!newRowExists) {
                  props.MarkedForDeletion2?.(props.selectedRowData2);
                } else {
                  props.NewYnErrorMsg?.();
                }
              }}
              onCellClicked1={(e) => {
                const clickedIndex = e.rowIndex;

                if (props.currentRowIndexRef1?.current === clickedIndex) {
                  return;
                }

                props.SearchLogic2?.(e.data.PL_TYPE);
                props.handleRowSelection1?.(e.data, clickedIndex);
              }}
              onSelectionChanged2={() => {
                const gridApi = props.gridRef2?.current?.api;
                const selectedNodes = gridApi.getSelectedNodes();
                const selectedData = selectedNodes.map((n) => n.data);

                props.selectedRowNosRef2.current = new Set(
                  selectedData.map((r) => r.no)
                );
                props.setSelectedRowData2(selectedData);
              }}
            />
          }
        />
      </Grid>
      {props.modalToggle1 && (
        <div
          role="presentation"
          className="MuiDialog-root MuiModal-root"
          inert="true"
        >
          <Dialog
            title={'프로그램ID'}
            open={props.modalToggle1}
            onClose={() => {
              props.setModalToggle1(false);
            }}
            contentSx={{ display: 'flex', flexDirection: 'column' }}
            fullWidth
            saveButtonName={'선택'}
            closeButtonName={'닫기'}
            useSaveButton={true}
            useSaveAfterClose={false}
            maxWidth="md"
            onSave={() => {
              props.handleSaveFromModal?.();
            }}
            content={
              <div
                className="ag-theme-alpine no-scroll"
                style={{ height: '600px', width: '100%' }}
              >
                <AgGridReact
                  getRowId={(params) => String(params.data?.no ?? '')}
                  ref={props.gridRef3}
                  animationRows={true}
                  columnDefs={columnDefs3}
                  rowData={props.modalRowData1}
                  defaultColDef={{
                    minWidth: 100,
                    editable: false,
                    resizable: true,
                    sortable: true,
                    filter: true,
                    floatingFilter: true,
                  }}
                  suppressCellFocus={true}
                  stopEditingWhenCellsLoseFocus={true}
                  rowSelection="multiple"
                  onSelectionChanged={() => {
                    const gridApi = props.gridRef3?.current?.api;
                    const selectedNodes = gridApi.getSelectedNodes();
                    const selectedData = selectedNodes.map((n) => n.data);

                    props.selectedRowNosRef3.current = new Set(
                      selectedData.map((r) => r.no)
                    );
                    props.setSelectedModalRowData1(selectedData);
                  }}
                  onRowDoubleClicked={(e) => {
                    props.handleSaveFromModal?.(e.data);
                  }}
                />
              </div>
            }
          />
        </div>
      )}
      <Dialog
        open={props.confirmOpen}
        onClose={() => props.setConfirmOpen(false)}
        title="저장 확인"
        content={
          <div>{`${props.pendingRows.length}개의 데이터를 저장하시겠습니까?`}</div>
        }
        contentSx={{ display: 'flex', flexDirection: 'column' }}
        saveButtonName="확인"
        closeButtonName="취소"
        useSaveButton
        onSave={() => {
          const plType = props.selectedRowData1?.[0]?.PL_TYPE;
          if (plType) {
            props.SaveLogic2?.(plType, props.pendingRows);
          }
        }}
      />
    </Grid>
  );
}

export default IND_BASIC;
